import { useState } from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { usePatchPaymentDetailsMutation } from '../../services/accountPayableApi';
export function usePatchPaymentDetails() {
    const { t } = useTranslation();
    const [trigger] = usePatchPaymentDetailsMutation();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();
    const [paymentDetails, setPaymentDetails] = useState();
    async function patchPaymentDetails(id, body) {
        setLoading(true);
        setError(undefined);
        setPaymentDetails(undefined);
        try {
            const { data } = await trigger({ id, body });
            if (!data?.result) {
                setError(t('can-not-update-bank-details'));
            }
            else {
                setPaymentDetails(data.result);
            }
        }
        catch {
            setError(t('can-not-update-bank-details'));
        }
        finally {
            setLoading(false);
        }
    }
    return {
        loading,
        setLoading,
        error,
        setError,
        paymentDetails,
        setPaymentDetails,
        patchPaymentDetails,
    };
}
